import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full min-h-screen flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Cameroonian%20street%20food%20market%20scene%20Douala%20vibrant%20colorful%20spices%20piles%20fresh%20vegetables%20grilled%20fish%20smoky%20atmosphere%20local%20vendors%20cooking%20traditional%20dishes%20warm%20golden%20afternoon%20sunlight%20authentic%20African%20marketplace%20bustling%20crowd%20natural%20candid%20editorial%20photography%20high%20detail%20cinematic%20composition&width=1600&height=900&seq=hero-bg-mayouk-v2&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-center"
        />
        {/* Overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60"></div>
        {/* Texture layer */}
        <div className="absolute inset-0 bg-gradient-to-t from-primary-950/30 to-transparent"></div>
      </div>

      {/* Content */}
      <div className="relative w-full px-4 md:px-6 lg:px-10 pt-24 md:pt-32 pb-16 md:pb-20">
        <div className="max-w-5xl mx-auto text-center">
          {/* Location badge */}
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/10 backdrop-blur-sm border border-background-50/20 text-background-50 text-xs font-medium mb-8 animate-fade-in">
            <div className="w-1.5 h-1.5 rounded-full bg-accent-400"></div>
            <span className="whitespace-nowrap">Douala & Yaounde, Cameroun</span>
          </div>

          <h1 className="font-heading text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-extrabold text-background-50 leading-tight mb-6 animate-slide-up tracking-tight">
            {t("hero.headline")}
          </h1>

          <p className="text-lg md:text-xl text-background-200/90 leading-relaxed mb-10 max-w-2xl mx-auto animate-slide-up">
            {t("hero.subheadline")}
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 animate-slide-up">
            <Link
              to="/waitlist"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-4 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-all hover:scale-105 shadow-lg shadow-primary-500/25 whitespace-nowrap cursor-pointer"
            >
              {t("hero.cta_waitlist")}
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line"></i>
              </div>
            </Link>
            <Link
              to="/vendors"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-4 bg-background-50/10 backdrop-blur-sm border border-background-50/30 text-background-50 rounded-full text-sm font-semibold hover:bg-background-50/20 transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              {t("hero.cta_vendor")}
            </Link>
            <Link
              to="/riders"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-4 bg-accent-500 text-background-50 rounded-full text-sm font-semibold hover:bg-accent-600 transition-all hover:scale-105 shadow-lg shadow-accent-500/25 whitespace-nowrap cursor-pointer"
            >
              {t("hero.cta_rider")}
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-motorbike-line"></i>
              </div>
            </Link>
          </div>

          {/* Stats row */}
          <div className="mt-16 md:mt-20 flex flex-wrap items-center justify-center gap-8 md:gap-16">
            <div className="text-center">
              <p className="font-heading text-3xl md:text-4xl font-bold text-background-50">500+</p>
              <p className="text-xs md:text-sm text-background-300/80 mt-1">Vendeurs locaux</p>
            </div>
            <div className="w-px h-10 bg-background-50/20 hidden sm:block"></div>
            <div className="text-center">
              <p className="font-heading text-3xl md:text-4xl font-bold text-background-50">200+</p>
              <p className="text-xs md:text-sm text-background-300/80 mt-1">Livreurs moto</p>
            </div>
            <div className="w-px h-10 bg-background-50/20 hidden sm:block"></div>
            <div className="text-center">
              <p className="font-heading text-3xl md:text-4xl font-bold text-background-50">2</p>
              <p className="text-xs md:text-sm text-background-300/80 mt-1">Villes couvertes</p>
            </div>
          </div>

          {/* Scroll indicator */}
          <div className="absolute bottom-6 left-1/2 -translate-x-1/2 animate-pulse-slow">
            <div className="w-5 h-8 rounded-full border-2 border-background-50/40 flex items-start justify-center p-1">
              <div className="w-1 h-2 rounded-full bg-background-50/60 animate-float"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}